






































































































/* eslint-disable no-param-reassign */
import { Proposal } from '@/interfaces/Proposal';
import { Vue, Component, Prop } from 'vue-property-decorator';
import UploadPhoto from './UploadPhoto.vue';

@Component({
  components: { UploadPhoto },
})
export default class ProposalCard extends Vue {
  @Prop()
  public proposal!: Proposal;

  @Prop({ required: false })
  public hideLocationButton!: boolean;

  get edit(): boolean {
    return this.$store.getters.isDeveloper;
  }

  jumpToProposal(proposal: Proposal): void {
    this.$store.commit('setSelectedProposal', { proposal, selected: true });
    this.$router.push('/');
  }

  // eslint-disable-next-line class-methods-use-this
  toggleHeart(proposal: Proposal): void {
    proposal.voted = !proposal.voted;
    proposal.votes += (proposal.voted ? 1 : -1);
  }
}
